import { LastRouterService } from "../last-route.service";
import { BreadCrumbModel } from "gaming-component-ngx-common";
import {SortControlComponent} from "gaming-component-ngx-common";
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { EntityDetailsData } from '../models/breach-details-model';
import { BreachDetailsDataService } from "../services/breach-details-data-service";
import { CacheService } from "../services/cache.service";

@Component({
  providers: [BreachDetailsDataService],
  selector: 'breachDetails',
  templateUrl: './breach-details.component.html'
})
export class BreachDetailsComponent implements OnInit {
  public breadCrumbModel: BreadCrumbModel =
    new BreadCrumbModel(true, ["/breachesList"], "Back to Breaches",
      new BreadCrumbModel(true, ["/breachesList"], "Breaches", null)
    );
  public data: EntityDetailsData = null;
  public reportTitle: string;
  public errorState: string;
  public isLoading: boolean = true;
  public path: string;
  private breachDataService: BreachDetailsDataService;
  private venueId: string;
  private breachType: string;
  private dateDetected: string;
  
  constructor(bds: BreachDetailsDataService, private route: ActivatedRoute, private lastRouter: LastRouterService, private cacheService: CacheService) {
    this.breachDataService = bds;
    this.venueId = decodeURI(route.snapshot.params["venueId"]);
    this.breachType = decodeURI(route.snapshot.params["breachType"]);
    this.reportTitle = this.breachType + " Breach";
    this.dateDetected = decodeURI(route.snapshot.params["dateDetected"]);
    this.path = lastRouter.lastRoute;

    const cachedVenueId = this.cacheService.getBreachListFilters().venueId;
    if (cachedVenueId) {
      // If venueId filter was used in breach list page need to update breadCrumbModel
      this.breadCrumbModel =
        new BreadCrumbModel(true, [`/breachesList/${cachedVenueId}`], "Back to Breaches",
          new BreadCrumbModel(true, [`/breachesList/${cachedVenueId}`], "Breaches", null)
        );
    }
  }

  ngOnInit() {
    this.breachDataService.getBreachData([this.venueId, this.breachType, this.dateDetected]).then(
      (rslt) => {
        this.data = rslt;
        // Fix address format
        this.data.address = this.fixAddressFormat(this.data.address);
        // Fix email address
        this.data.email = this.fixEmailFormat(this.data.email);

        SortControlComponent.ChangeTableSort(this.data.tableData);
        this.breadCrumbModel.child.child =
          new BreadCrumbModel(false, [""], this.data.venue,
            new BreadCrumbModel(false, [""], this.reportTitle, null)
          );
        this.isLoading = false;
      },
    )
    .catch((error) => {
      console.error(error);
      this.errorState = JSON.stringify(error);
    });
  }

  private fixAddressFormat(address: string): string {
    let rv = '';
    if (address) {
      let arrAddrItem = address.split(' , ');
      if (arrAddrItem.length > 1) {
        arrAddrItem.forEach(addrItem => {
          if (addrItem.trim() !== '') { // Ignore empty address item
            if (rv !== '') { rv = rv + ", "; }
            rv = rv + addrItem.trim();
          }
        });
      }
    }
    return rv;
  }

  private fixEmailFormat(email: string): string {
    let rv = email || '';
    return rv.toLowerCase();
  }

}



// WEBPACK FOOTER //
// ./client/app/breaches/breach-details.component.ts